"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const framer_motion_1 = require("framer-motion");
const isArray_1 = tslib_1.__importDefault(require("lodash/fp/isArray"));
const head_1 = tslib_1.__importDefault(require("lodash/fp/head"));
const noop_1 = tslib_1.__importDefault(require("lodash/noop"));
const useAfterMount_1 = tslib_1.__importDefault(require("../../useAfterMount"));
const animationPropsForStyle = {
    fromLeft: {
        initial: { x: -10, y: 0, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        exit: { x: -10, y: 0, opacity: 0 },
    },
    fromRight: {
        initial: { x: 10, y: 0, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        exit: { x: 10, y: 0, opacity: 0 },
    },
    fromTop: {
        initial: { y: -10, x: 0, opacity: 0 },
        animate: { y: 0, x: 0, opacity: 1 },
        exit: { y: -10, x: 0, opacity: 0 },
    },
    fromBottom: {
        initial: { y: 10, x: 0, opacity: 0 },
        animate: { y: 0, x: 0, opacity: 1 },
        exit: { y: 10, x: 0, opacity: 0 },
    },
    fade: {
        initial: { x: 0, y: 0, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        exit: { x: 0, y: 0, opacity: 0 },
    },
    tabs: {
        initial: { x: 2, y: 0, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        exit: { x: -2, y: 0, opacity: 0 },
    },
    page: {
        initial: 'pageEnter',
        animate: 'pageCenter',
        exit: 'pageExit',
    },
    pageBack: {
        initial: 'pageEnter',
        animate: 'pageCenter',
        exit: 'pageExit',
    },
};
const getPageDirection = (animationStyle) => animationStyle === 'pageBack' ? -1 : 1;
const pageTransitionVariants = {
    pageEnter: (pageDirection) => ({ x: `${pageDirection * 60}%`, opacity: 0 }),
    pageCenter: { x: 0, opacity: 1 },
    pageExit: (pageDirection) => ({ zIndex: 0, x: `${-pageDirection * 60}%`, opacity: 0 }),
};
const Fade = (props) => {
    const { show = true, initial = false, duration = 0.2, exitBeforeEnter = false, animationStyle = 'fade', animatePresenceProps, motionProps, onExitComplete = noop_1.default, children, } = props;
    const [allowInitialAnimation, setAllowInitialAnimation] = (0, react_1.useState)(initial);
    (0, useAfterMount_1.default)(() => {
        if (!allowInitialAnimation) {
            setAllowInitialAnimation(true);
        }
    });
    let motionDivKey = 'fade';
    // If there are multiple children that are conditionally rendered like
    // in case of a tabbed content - get the current visible child key
    // to update the motion.div key to animate different children
    if ((0, isArray_1.default)(children)) {
        const currentChild = (0, head_1.default)(children.filter(child => Boolean(child)));
        motionDivKey = `fade-${currentChild.key}`;
    }
    // In case the animation is a page transition, use custom variants and add a custom pageDirection variable
    // to animate in the right direction
    const isPageTransition = animationStyle === 'page' || animationStyle === 'pageBack';
    const pageDirection = getPageDirection(animationStyle);
    const custom = isPageTransition ? pageDirection : null;
    const pageTransitionProps = isPageTransition ? { variants: pageTransitionVariants } : null;
    const selectedAnimationProps = animationPropsForStyle[animationStyle];
    // Disable initial animation on mount. After mount the initial animation step is needed to enable
    // the "fade-in" animation, otherwise it just appears
    const selectedInitial = allowInitialAnimation ? selectedAnimationProps.initial : false;
    const animationProps = Object.assign(Object.assign({}, selectedAnimationProps), { initial: selectedInitial });
    return (
    // @ts-ignore-next-line
    (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ initial: allowInitialAnimation, exitBeforeEnter: exitBeforeEnter, onExitComplete: onExitComplete, custom: custom }, animatePresenceProps, { children: show && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, Object.assign({ transition: { duration }, custom: custom }, animationProps, pageTransitionProps, motionProps, { children: children }), motionDivKey)) })));
};
Fade.FADE = 'fade';
Fade.FROM_LEFT = 'fromLeft';
Fade.FROM_RIGHT = 'fromRight';
Fade.FROM_TOP = 'fromTop';
Fade.FROM_BOTTOM = 'fromBottom';
Fade.TABS = 'tabs';
Fade.PAGE = 'page';
Fade.PAGE_BACK = 'pageBack';
exports.default = Fade;
